import type { WordsAndDefinitionsType } from "../../features/activities/MatchWordsActivity/type";

export const extractBoldWords = (markdown: string) => {
	const regex = /\*\*(.*?)\*\*/g;
	let match: RegExpExecArray | null;
	const boldWords = [];

	while (true) {
		match = regex.exec(markdown);
		if (match === null) {
			break;
		}
		boldWords.push(match[1]);
	}

	return boldWords;
};

export const extractAndCleanSentences = (markdown: string) => {
	const regex = /\*(.*?)\*/g;
	let match: RegExpExecArray | null;
	const extractedSentences = [];

	while (true) {
		match = regex.exec(markdown);
		if (match === null) {
			break;
		}
		const content = match[1];
		if (content.split(" ").length > 1) {
			// Check if it's more than one word
			extractedSentences.push(content);
		}
	}

	return extractedSentences;
};

export const storeDataInLocalStorage = (
	lessonId: string,
	activityId: string,
	data: WordsAndDefinitionsType[],
) => {
	const key = `wordsAndDefinitions_${lessonId}_${activityId}`;
	localStorage.setItem(key, JSON.stringify(data));
};

export const getDataFromLocalStorage = (
	lessonId: string,
	activityId: string,
) => {
	const key = `wordsAndDefinitions_${lessonId}_${activityId}`;
	const storedData = localStorage.getItem(key);
	return storedData ? JSON.parse(storedData) : null;
};

export const getDefinitionsForWords = async (words: string[]) => {
	const promises = words?.map(async (word) => {
		try {
			const res = await fetch(
				`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`,
			);
			const data = await res.json();

			const definition = data?.[0]?.meanings?.[0]?.definitions?.[0]?.definition;

			if (definition) {
				return {
					word,
					definition,
				};
			}
		} catch (error) {
			console.log(error);
		}
	});

	const results = (await Promise.all(promises)).filter(Boolean);
	return results;
};

export const shuffle = (array: string[]) => {
	let currentIndex = array.length;
	let randomIndex = null;

	// While there remain elements to shuffle.
	while (currentIndex > 0) {
		// Pick a remaining element.
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex--;

		// And swap it with the current element.
		[array[currentIndex], array[randomIndex]] = [
			array[randomIndex],
			array[currentIndex],
		];
	}

	return array;
};

type playSynthesisUtteranceType = {
	word: string;
	onStart?: () => void;
	onEnd?: () => void;
	language: string;
};

const getTTSLangFromLanguage = (language: string) => {
	switch (language) {
		case "english":
			return "en-EN";
		case "russian":
			return "ru-RU";
		default:
			return "en-EN";
	}
};

export const playSynthesisUtterance = ({
	word,
	onStart,
	onEnd,
	language = "english",
}: playSynthesisUtteranceType) => {
	const lang = getTTSLangFromLanguage(language);
	const tts = window.speechSynthesis;
	tts.cancel();
	const voices = tts.getVoices();
	const voice = voices.find((voice) => voice.lang === lang);

	console.log(lang);

	const toSpeak = new SpeechSynthesisUtterance(word);
	if (onStart) {
		toSpeak.onstart = () => {
			onStart();
		};
	}

	toSpeak.onerror = () => {
		console.log("error");
	};

	if (onEnd) {
		toSpeak.onend = () => {
			onEnd();
		};
	}
	console.log(tts);
	toSpeak.lang = lang;
	toSpeak.pitch = 1;
	toSpeak.rate = 1;
	toSpeak.voice = voice ?? voices[6];
	tts.speak(toSpeak);
};

export const formClass = (
	mainClass: string,
	blockClass?: string,
	modifierClass?: string,
) => {
	let className = mainClass;
	if (blockClass) {
		className += `__${blockClass}`;
	}
	if (modifierClass) {
		className += `--${modifierClass}`;
	}
	return className;
};
